import {takeLatest} from "redux-saga";
import {fork, put, take, race} from "redux-saga/effects";
import {generateUUID} from "../lib/UUID";
import * as CheckoutApiActions from "../actions/CheckoutApiActions";
import * as AccountApiActions from "../actions/AccountApiActions";
import {
  showModalWindow,
  removeModalWindow,
  updateModalWindow
  } from "../actions/WindowActions";
import MessageBus from "../lib/MessageBus";
import {Map} from "immutable";

/* eslint-disable require-yield  */
function* beginCheckout(baseAction) {
  MessageBus.publish("navigation", "goto", {
    url: `/checkout/${baseAction.accountId}/${baseAction.orderId}`
  })
}
/* eslint-enable require-yield  */
function* watchBeginCheckout() {
  yield takeLatest(AccountApiActions.BEGIN_CHECKOUT, beginCheckout);
}

function* requestAddShippingAddress(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CheckoutAddShippingAddressWindow", {accountId: baseAction.accountId, orderId: baseAction.orderId}, "Add Shipping Address"));
  yield take([CheckoutApiActions.ADD_SHIPPING_ADDRESS.CANCEL, CheckoutApiActions.ADD_SHIPPING_ADDRESS.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAddShippingAddress() {
  yield takeLatest(CheckoutApiActions.REQUEST_ADD_SHIPPING_ADDRESS, requestAddShippingAddress);
}

function* requestChangeShippingAddress(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CheckoutChangeShippingAddressWindow", {accountId: baseAction.accountId, orderId: baseAction.orderId}, "Change Shipping Address"));
  yield take([CheckoutApiActions.CHANGE_SHIPPING_ADDRESS.CANCEL, CheckoutApiActions.CHANGE_SHIPPING_ADDRESS.SUCCESS, CheckoutApiActions.REQUEST_ADD_SHIPPING_ADDRESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangeShippingAddress() {
  yield takeLatest(CheckoutApiActions.REQUEST_CHANGE_SHIPPING_ADDRESS, requestChangeShippingAddress);
}

function* requestEditShippingAddress(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CheckoutEditShippingAddressWindow", {accountId: baseAction.accountId, orderId: baseAction.orderId}, "Edit Shipping Address"));
  yield take([CheckoutApiActions.EDIT_SHIPPING_ADDRESS.CANCEL, CheckoutApiActions.EDIT_SHIPPING_ADDRESS.SUCCESS, CheckoutApiActions.REQUEST_ADD_SHIPPING_ADDRESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestEditShippingAddress() {
  yield takeLatest(CheckoutApiActions.REQUEST_EDIT_SHIPPING_ADDRESS, requestEditShippingAddress);
}

function* requestAddGiftMessage(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CheckoutAddGiftMessageWindow", {orderId: baseAction.orderId}, "Add Gift Message"));
  yield take([CheckoutApiActions.ADD_GIFT_MESSAGE.CANCEL, CheckoutApiActions.ADD_GIFT_MESSAGE.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAddGiftMessage() {
  yield takeLatest(CheckoutApiActions.REQUEST_ADD_GIFT_MESSAGE, requestAddGiftMessage);
}

function* requestEditGiftMessage(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CheckoutEditGiftMessageWindow", {orderId: baseAction.orderId, message: baseAction.message}, "Edit Gift Message"));
  yield take([CheckoutApiActions.EDIT_GIFT_MESSAGE.CANCEL, CheckoutApiActions.EDIT_GIFT_MESSAGE.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestEditGiftMessage() {
  yield takeLatest(CheckoutApiActions.REQUEST_EDIT_GIFT_MESSAGE, requestEditGiftMessage);
}

function* requestRemoveGiftMessage(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CheckoutRemoveGiftMessageWindow", {orderId: baseAction.orderId}, "Remove Gift Message"));
  yield take([CheckoutApiActions.REMOVE_GIFT_MESSAGE.CANCEL, CheckoutApiActions.REMOVE_GIFT_MESSAGE.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRemoveGiftMessage() {
  yield takeLatest(CheckoutApiActions.REQUEST_REMOVE_GIFT_MESSAGE, requestRemoveGiftMessage);
}

// Cancel checkout.
function* requestCancelCheckout(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CancelCheckoutWindow", {accountId: baseAction.accountId, orderId: baseAction.orderId}, "Cancelling Checkout"));
  yield take([CheckoutApiActions.CANCEL_CHECKOUT.CANCEL, CheckoutApiActions.CANCEL_CHECKOUT.SUCCESS]);
  yield put(removeModalWindow(windowId));
  if (baseAction.redirect) {
    MessageBus.publish("navigation", "goto", {
      url: `/accounts/${baseAction.accountId}`
    })    
  }
}
function* watchRequestCancelCheckout() {
  yield takeLatest(CheckoutApiActions.REQUEST_CANCEL_CHECKOUT, requestCancelCheckout);
}

function* watchRequestPlaceOrder() {
  while(true) {
    let baseAction = yield take(CheckoutApiActions.REQUEST_SHOW_ORDER_STATUS);
    let windowId = generateUUID();
    yield put(showModalWindow(windowId, "PlaceOrderWindow", {accountId: baseAction.accountId, orderId: baseAction.orderId, status: baseAction.status, errorMsg: baseAction.errorMsg, invoiceNr: baseAction.invoiceNr}, "", Map({headless: true})));
    let showWindow = true;
    while(showWindow) {
      const {cancelled, succeeded, statusChange} = yield race({
        cancelled: take((action) => action.type === CheckoutApiActions.SHOW_ORDER_STATUS.CANCEL),
        succeeded: take((action) => action.type === CheckoutApiActions.SHOW_ORDER_STATUS.SUCCESS),
        statusChange: take((action) => action.type === CheckoutApiActions.REQUEST_SHOW_ORDER_STATUS)
      })
      if (succeeded) {
        MessageBus.publish("navigation", "goto", {
          url: `/sales/orders/${baseAction.orderId}`
        })    
        showWindow = false;   
      }
      if (statusChange) {
        yield put(updateModalWindow(windowId, {accountId: baseAction.accountId, orderId: baseAction.orderId, status: statusChange.status, errorMsg: statusChange.errorMsg, invoiceNr: statusChange.invoiceNr}, "", Map({headless: true})));  
      }
      if (cancelled) {
        showWindow = false;
      }
    }
    yield put(removeModalWindow(windowId));
  }
}



export default function* saga() {
  yield fork(watchBeginCheckout);
  yield fork(watchRequestAddShippingAddress);
  yield fork(watchRequestChangeShippingAddress);
  yield fork(watchRequestEditShippingAddress);
  yield fork(watchRequestAddGiftMessage);
  yield fork(watchRequestEditGiftMessage);
  yield fork(watchRequestRemoveGiftMessage);
  yield fork(watchRequestCancelCheckout);
  yield fork(watchRequestPlaceOrder);
}
